import { render, staticRenderFns } from "./TripStatisticBarItem.vue?vue&type=template&id=116e9474&"
import script from "./TripStatisticBarItem.vue?vue&type=script&lang=ts&"
export * from "./TripStatisticBarItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports